export default "__VITE_ASSET__xwnOwTlx__"